import * as React from 'react';

import {
  AddressData,
  ChatbotData,
  Configuration,
  PonyfillFactoryCredentials,
  UserData,
  ViewsConfiguration,
  NewsConfig,
  AvailableViews,
  CustomVoice,
  characters,
  WidgetConfiguration,
  RetorikThemeColors
} from '@davi-ai/retorik-framework'
import { botEventHandler } from './BotEventHandler';

const config: Configuration = {
  isUsedOnBorne: true,
  position: {
    searchForLocation: true
  },
  // locales: {
  //   default: 'fr-FR'
  // },
  logo: {
    src: 'images/logo_ajadi.png'
  },
  subtitles: true,
  answerpanel: true,
  skipWelcome: true,
  preventExpectedInputHint: true,
  companyName: 'Mon entreprise',
  baseMenu:[
    { view: 1, indice: 1 },
    { view: 2, indice: 2 },
    { view: 3, indice: 3 },
    { view: 4, indice: 4 }
  ],
  customMenu: [],
  hideMenu:true
}

const viewsConfig: ViewsConfiguration = {
  homeRoute: 'home',
  webcamRotation: 90,
  views: {
    home: {
      background: {
        image: 'images/background.webp',
        video: 'videos/Varkala_Beach.webm',
        webcam:
          'd0a718dea3a09715f553c15bc09b8396c01c98ad76b9af287673f5d303dc3191',
        // neutral: '#a86232',
        style: 'image'
      }
    },
    news: {
      intervalInSeconds: 2,
      loop: true,
      openingVideo: 'videos/intro.mp4',
      background: {
        style: 'neutral',
        image: 'images/background.webp'
      }
    }
  }
}

const frameworkColors : RetorikThemeColors = {
  formInput:{
    text:{
      default:"#00d7ff"
    }
  }
}

const chatbotData: ChatbotData = {
  size: undefined,
  height: undefined
}

const tenants: { [key: string]: AddressData } = {
  ajadi: {
    tenant: 'ajadi',
    prefix: ''
  },
  ajadiLocal: {
    baseURI:"https://7604-2a02-842b-36f-c501-4c76-60c7-3235-6bc7.ngrok.io/K2.ContentFields.WebChat/api/GetWebchatToken",
    tenant: '',
    prefix: ''
  },
}

const addressData: AddressData = tenants["ajadi"]


type CustomAjadiData = {
  company : string,
  mail : string
}
const userData: UserData & CustomAjadiData= {
  name: '',
  id: Math.random().toString(36).substring(2, 9),
  username: '',
  nom: '',
  prenom: '',
  email: '',
  token: '',
  referrer: '',
  ipaddress: '',
  company : '',
  mail: ''
}



const ponyfillFactoryCredentials: PonyfillFactoryCredentials = {
  region: 'francecentral',
  subscriptionKey: '2f62867e22a544b78a16c99a2707ef49'
}

const voices = {
  guy: {
    voice: 'GuyNeural'
  },
  henri: {
    voice: 'HenriNeural'
  },
  brigitte: {
    voice: 'BrigitteNeural'
  },
  multi: {
    voice: 'JennyMultilingualNeural'
  }
}

const newsConfig: NewsConfig = {
  intervalInSeconds: 3,
  loop: true,
  openingVideo: 'videos/intro.mp4',
  background: {
    style: 'image',
    image: 'images/background_MTC.jpg'
  }
}

const agentData = characters.lea


const customVoice : CustomVoice = {
  gender: 'female',
  voice:voices.brigitte.voice
}

const widgetConfig: WidgetConfiguration = {
  button: {
    text: {
      content: 'Ouvrir le bot ',
      color: 'rgb(0, 74, 104)'
      // bold: false
    },
    image: {
      url: 'images/Aneo.png',
    },
    border: {
      color: 'rgb(0, 74, 104)'
      // thickness: 3,
    }
  },
  large: {
  }
  
}

export type RetorikConfiguration = {
  config : Configuration,
  chatbotData: ChatbotData
  agentData : string
  ponyfillFactoryCredentials: PonyfillFactoryCredentials
  addressData: AddressData
  userData: UserData & CustomAjadiData
  externalEventHandler?: Function
  customVoice: CustomVoice
  viewsConfig : ViewsConfiguration
  skipLoader : boolean
  frameworkColors : RetorikThemeColors,
}

export const BaseRetorikConfig : RetorikConfiguration = {
  config,
  chatbotData,
  addressData,
  userData,
  ponyfillFactoryCredentials,
  externalEventHandler: botEventHandler,
  agentData,
  customVoice,
  viewsConfig,
  skipLoader:true,
  frameworkColors,
}
